export default {
  data() {
    return {
      tables: {
        headers: [
          { text: 'Номер', value: 'barcode.code', sortable: false, align: 'left' },
          { text: 'Название', value: 'product.name', sortable: false, align: 'left' },
          { text: 'Кол-во', value: 'quantity', sortable: false, align: 'right' },
          { text: 'Цена', value: 'cost', sortable: false, align: 'right' },
          { text: 'Бонусы', value: 'bonuses', sortable: false, align: 'right' },
        ],
      },
      history: [],
      showHistoryID: false,
      editStatuses: ['adminReview', 'draft', 'redo'],
      showPhoto: false,
      currentPhoto: null,
      showPdf: false,
      currentPdf: null,
      isLoadPage: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    installations() {
      return this.$store.state.installations.installations;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    isEdit(status) {
      return this.editStatuses.indexOf(status) > -1;
    },

    getInstallationQuantity(id) {
      const installation = this.installations.filter(item => item.id === id);
      let quantity = 0;
      if (installation[0].positions) {
        quantity = installation[0].positions.reduce((acc1, d1) => {
          acc1 += d1.quantity;
          return acc1;
        }, 0);
      }
      return quantity;
    },
    getInstallationBonuses(id) {
      const installation = this.installations.filter(item => item.id === id);
      let bonuses = 0;
      if (installation[0].positions) {
        bonuses = installation[0].positions.reduce((acc1, d1) => {
          acc1 += d1.bonuses;
          return acc1;
        }, 0);
      }
      return bonuses;
    },
    addInstallation(id, actionId) {
      this.$store.dispatch('installations/GetInstallation', id);
      this.$router.push(`/installation/${actionId}/${id}`);
    },
    showHistory(id) {
      const installation = this.installations.filter(item => item.id === id);
      this.history = installation.length ? installation[0].history : [];
      this.showHistoryID = (this.showHistoryID !== id) ? id : false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'redo': return 'color-orange';
        case 'draft': return 'color-orange';
        case 'declined': return 'color-red';
        case 'paid': return 'color-green';
        case 'approved': return 'color-green';
        case 'verified': return 'color-green';
        default: return '';
      }
    },
    ShowPhoto(photo) {
      this.showPhoto = true;
      this.currentPhoto = { ...photo };
    },
    ClosePhoto() {
      this.showPhoto = false;
      this.currentPhoto = null;
    },
    ShowPdf(photo) {
      this.showPdf = true;
      this.currentPdf = `<iframe src="${photo.url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
    CheckPDF(photo) {
      if (photo.base64) {
        return (photo.base64.indexOf('/pdf;') !== -1);
      }
      if (photo.url) {
        return (photo.url.indexOf('.pdf') !== -1);
      }
      return false;
    },
    ClosePdf() {
      this.showPdf = false;
      this.currentPdf = null;
    },
  },
  mounted() {
    this.$store.dispatch('installations/GetInstallationsList', { profile_id: this.user.profile_id });
    // this.$store.dispatch('installations/GetProductsList');
  },
};
